<!-- `.mchips` (P/Member_Hub.html:922-937): Filters, the sort select, then the group chips. -->
<div class="agu-mchips" role="group" aria-label="Filters and sort">
    <button type="button" class="agu-mchips__chip agu-mchips__filter" [attr.aria-label]="FilterAriaLabel" (click)="OpenAll()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 6h16M7 12h10M10 18h4" /></svg>
        <span>Filters</span>
        @if (FilterCount > 0) {
            <b>{{ CountLabel }}</b>
        }
    </button>
    @if (SelectOptions.length > 0) {
        <label class="agu-mchips__chip agu-mchips__sort">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 4v16M3 16l4 4 4-4M17 20V4M13 8l4-4 4 4" /></svg>
            <select #sortSelect aria-label="Sort results" (change)="PickSort(sortSelect.value)">
                @for (option of SelectOptions; track option.Key) {
                    <option [value]="option.Key" [selected]="option.Key === Sort">{{ option.Label }}</option>
                }
            </select>
        </label>
    }
    @for (group of VisibleGroups; track group) {
        <button type="button" class="agu-mchips__chip agu-mchips__group" [class.agu-mchips__group--on]="IsActive(group)" [attr.aria-label]="IsActive(group) ? group + ', filtered' : null" (click)="OpenGroup(group)">{{ group }}</button>
    }
</div>
